export default class VideoHelpers {
    static getFomattedDuration(durationSeconds) {
        const minutes = Math.floor(durationSeconds / 60);
        const seconds = durationSeconds - minutes * 60;

        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    }

    static parseYoutubeId(url) {
        let ID = '';
        url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if(url[2] !== undefined) {
            ID = url[2].split(/[^0-9a-z_\-]/i);
            ID = ID[0];
        }

        return ID;
    }
    static parseVimeoId(url) {
        let id = url.match(/\/\/[^\/]+\/([^\.]+)/)[1];
        if (typeof id === 'string') {
            id = id.split('/')[0];
        }
        return id;
    }
}



// WEBPACK FOOTER //
// ./components/video/scripts/video-helpers.js